const cache = {
    state: {
        cacheList: []
    },
    mutations: {
        ADD_CACHE: (state, param) => {
            let list = state.cacheList;
            if (list.length) {
              let isTrue = false;
              for (let i = 0; i < list.length; i++) {
                if (list[i].name === param.name) {
                    list[i] = param;
                    isTrue = true;
                    break;
                }
              }
              if (!isTrue) {
                state.cacheList.push(param);
              }
            } else {
               state.cacheList.push(param);
            }
        },
        DEL_CACHE: (state, name) => {
          state.cacheList = state.cacheList.filter(item => item.name !== name)
        }
    },
    actions: {
        addCache({ commit }, param) {
            commit('ADD_CACHE', param)
        },
        delCache({ commit }, name) {
            commit('DEL_CACHE', name)
        },
    }
}
export default cache;